var map = {
	"./_lib/build_formatting_tokens_reg_exp": "90e5",
	"./_lib/build_formatting_tokens_reg_exp/": "90e5",
	"./_lib/build_formatting_tokens_reg_exp/index": "90e5",
	"./_lib/build_formatting_tokens_reg_exp/index.js": "90e5",
	"./_lib/package": "5623",
	"./_lib/package.json": "5623",
	"./ar": "1034",
	"./ar/": "1034",
	"./ar/build_distance_in_words_locale": "5f15",
	"./ar/build_distance_in_words_locale/": "5f15",
	"./ar/build_distance_in_words_locale/index": "5f15",
	"./ar/build_distance_in_words_locale/index.js": "5f15",
	"./ar/build_format_locale": "6a58",
	"./ar/build_format_locale/": "6a58",
	"./ar/build_format_locale/index": "6a58",
	"./ar/build_format_locale/index.js": "6a58",
	"./ar/index": "1034",
	"./ar/index.d.ts": "cab3",
	"./ar/index.js": "1034",
	"./ar/package": "40a4",
	"./ar/package.json": "40a4",
	"./be": "6048",
	"./be/": "6048",
	"./be/build_distance_in_words_locale": "2d0d",
	"./be/build_distance_in_words_locale/": "2d0d",
	"./be/build_distance_in_words_locale/index": "2d0d",
	"./be/build_distance_in_words_locale/index.js": "2d0d",
	"./be/build_format_locale": "923e",
	"./be/build_format_locale/": "923e",
	"./be/build_format_locale/index": "923e",
	"./be/build_format_locale/index.js": "923e",
	"./be/index": "6048",
	"./be/index.d.ts": "764e",
	"./be/index.js": "6048",
	"./be/package": "e5ce",
	"./be/package.json": "e5ce",
	"./bg": "8acc",
	"./bg/": "8acc",
	"./bg/build_distance_in_words_locale": "ecad",
	"./bg/build_distance_in_words_locale/": "ecad",
	"./bg/build_distance_in_words_locale/index": "ecad",
	"./bg/build_distance_in_words_locale/index.js": "ecad",
	"./bg/build_format_locale": "46b7",
	"./bg/build_format_locale/": "46b7",
	"./bg/build_format_locale/index": "46b7",
	"./bg/build_format_locale/index.js": "46b7",
	"./bg/index": "8acc",
	"./bg/index.d.ts": "d692",
	"./bg/index.js": "8acc",
	"./bg/package": "8254",
	"./bg/package.json": "8254",
	"./ca": "5706",
	"./ca/": "5706",
	"./ca/build_distance_in_words_locale": "c2aa",
	"./ca/build_distance_in_words_locale/": "c2aa",
	"./ca/build_distance_in_words_locale/index": "c2aa",
	"./ca/build_distance_in_words_locale/index.js": "c2aa",
	"./ca/build_format_locale": "a9c5",
	"./ca/build_format_locale/": "a9c5",
	"./ca/build_format_locale/index": "a9c5",
	"./ca/build_format_locale/index.js": "a9c5",
	"./ca/index": "5706",
	"./ca/index.d.ts": "e9fe",
	"./ca/index.js": "5706",
	"./ca/package": "7cf1",
	"./ca/package.json": "7cf1",
	"./cs": "76f8",
	"./cs/": "76f8",
	"./cs/build_distance_in_words_locale": "64a0",
	"./cs/build_distance_in_words_locale/": "64a0",
	"./cs/build_distance_in_words_locale/index": "64a0",
	"./cs/build_distance_in_words_locale/index.js": "64a0",
	"./cs/build_format_locale": "8a9c",
	"./cs/build_format_locale/": "8a9c",
	"./cs/build_format_locale/index": "8a9c",
	"./cs/build_format_locale/index.js": "8a9c",
	"./cs/index": "76f8",
	"./cs/index.d.ts": "ac72",
	"./cs/index.js": "76f8",
	"./cs/package": "ae33",
	"./cs/package.json": "ae33",
	"./da": "eeea",
	"./da/": "eeea",
	"./da/build_distance_in_words_locale": "d8c8",
	"./da/build_distance_in_words_locale/": "d8c8",
	"./da/build_distance_in_words_locale/index": "d8c8",
	"./da/build_distance_in_words_locale/index.js": "d8c8",
	"./da/build_format_locale": "1a77",
	"./da/build_format_locale/": "1a77",
	"./da/build_format_locale/index": "1a77",
	"./da/build_format_locale/index.js": "1a77",
	"./da/index": "eeea",
	"./da/index.d.ts": "af95",
	"./da/index.js": "eeea",
	"./da/package": "8a10",
	"./da/package.json": "8a10",
	"./de": "6e0c",
	"./de/": "6e0c",
	"./de/build_distance_in_words_locale": "e485",
	"./de/build_distance_in_words_locale/": "e485",
	"./de/build_distance_in_words_locale/index": "e485",
	"./de/build_distance_in_words_locale/index.js": "e485",
	"./de/build_format_locale": "4c70",
	"./de/build_format_locale/": "4c70",
	"./de/build_format_locale/index": "4c70",
	"./de/build_format_locale/index.js": "4c70",
	"./de/index": "6e0c",
	"./de/index.d.ts": "d194",
	"./de/index.js": "6e0c",
	"./de/package": "ef0a",
	"./de/package.json": "ef0a",
	"./el": "747d",
	"./el/": "747d",
	"./el/build_distance_in_words_locale": "a3f1",
	"./el/build_distance_in_words_locale/": "a3f1",
	"./el/build_distance_in_words_locale/index": "a3f1",
	"./el/build_distance_in_words_locale/index.js": "a3f1",
	"./el/build_format_locale": "f13f",
	"./el/build_format_locale/": "f13f",
	"./el/build_format_locale/index": "f13f",
	"./el/build_format_locale/index.js": "f13f",
	"./el/index": "747d",
	"./el/index.d.ts": "d48e",
	"./el/index.js": "747d",
	"./el/package": "46cf",
	"./el/package.json": "46cf",
	"./en": "52cf",
	"./en/": "52cf",
	"./en/build_distance_in_words_locale": "2d96",
	"./en/build_distance_in_words_locale/": "2d96",
	"./en/build_distance_in_words_locale/index": "2d96",
	"./en/build_distance_in_words_locale/index.js": "2d96",
	"./en/build_format_locale": "e830",
	"./en/build_format_locale/": "e830",
	"./en/build_format_locale/index": "e830",
	"./en/build_format_locale/index.js": "e830",
	"./en/index": "52cf",
	"./en/index.d.ts": "0d8b",
	"./en/index.js": "52cf",
	"./en/package": "1092",
	"./en/package.json": "1092",
	"./eo": "501e",
	"./eo/": "501e",
	"./eo/build_distance_in_words_locale": "aab9",
	"./eo/build_distance_in_words_locale/": "aab9",
	"./eo/build_distance_in_words_locale/index": "aab9",
	"./eo/build_distance_in_words_locale/index.js": "aab9",
	"./eo/build_format_locale": "065d",
	"./eo/build_format_locale/": "065d",
	"./eo/build_format_locale/index": "065d",
	"./eo/build_format_locale/index.js": "065d",
	"./eo/index": "501e",
	"./eo/index.d.ts": "ec1f",
	"./eo/index.js": "501e",
	"./eo/package": "28f9",
	"./eo/package.json": "28f9",
	"./es": "fd2d",
	"./es/": "fd2d",
	"./es/build_distance_in_words_locale": "1847",
	"./es/build_distance_in_words_locale/": "1847",
	"./es/build_distance_in_words_locale/index": "1847",
	"./es/build_distance_in_words_locale/index.js": "1847",
	"./es/build_format_locale": "3bec",
	"./es/build_format_locale/": "3bec",
	"./es/build_format_locale/index": "3bec",
	"./es/build_format_locale/index.js": "3bec",
	"./es/index": "fd2d",
	"./es/index.d.ts": "81b1",
	"./es/index.js": "fd2d",
	"./es/package": "562c",
	"./es/package.json": "562c",
	"./fi": "9dd5",
	"./fi/": "9dd5",
	"./fi/build_distance_in_words_locale": "547b",
	"./fi/build_distance_in_words_locale/": "547b",
	"./fi/build_distance_in_words_locale/index": "547b",
	"./fi/build_distance_in_words_locale/index.js": "547b",
	"./fi/build_format_locale": "3b27",
	"./fi/build_format_locale/": "3b27",
	"./fi/build_format_locale/index": "3b27",
	"./fi/build_format_locale/index.js": "3b27",
	"./fi/index": "9dd5",
	"./fi/index.d.ts": "9348",
	"./fi/index.js": "9dd5",
	"./fi/package": "c76a",
	"./fi/package.json": "c76a",
	"./fil": "a4d7",
	"./fil/": "a4d7",
	"./fil/build_distance_in_words_locale": "baae",
	"./fil/build_distance_in_words_locale/": "baae",
	"./fil/build_distance_in_words_locale/index": "baae",
	"./fil/build_distance_in_words_locale/index.js": "baae",
	"./fil/build_format_locale": "77b8",
	"./fil/build_format_locale/": "77b8",
	"./fil/build_format_locale/index": "77b8",
	"./fil/build_format_locale/index.js": "77b8",
	"./fil/index": "a4d7",
	"./fil/index.d.ts": "e526",
	"./fil/index.js": "a4d7",
	"./fil/package": "25a5",
	"./fil/package.json": "25a5",
	"./fr": "2ca0",
	"./fr/": "2ca0",
	"./fr/build_distance_in_words_locale": "2333",
	"./fr/build_distance_in_words_locale/": "2333",
	"./fr/build_distance_in_words_locale/index": "2333",
	"./fr/build_distance_in_words_locale/index.js": "2333",
	"./fr/build_format_locale": "2376",
	"./fr/build_format_locale/": "2376",
	"./fr/build_format_locale/index": "2376",
	"./fr/build_format_locale/index.js": "2376",
	"./fr/index": "2ca0",
	"./fr/index.d.ts": "844e",
	"./fr/index.js": "2ca0",
	"./fr/package": "85ea",
	"./fr/package.json": "85ea",
	"./hr": "2fd2",
	"./hr/": "2fd2",
	"./hr/build_distance_in_words_locale": "0cfb",
	"./hr/build_distance_in_words_locale/": "0cfb",
	"./hr/build_distance_in_words_locale/index": "0cfb",
	"./hr/build_distance_in_words_locale/index.js": "0cfb",
	"./hr/build_format_locale": "a6ec",
	"./hr/build_format_locale/": "a6ec",
	"./hr/build_format_locale/index": "a6ec",
	"./hr/build_format_locale/index.js": "a6ec",
	"./hr/index": "2fd2",
	"./hr/index.d.ts": "a4ae",
	"./hr/index.js": "2fd2",
	"./hr/package": "7187",
	"./hr/package.json": "7187",
	"./hu": "366f",
	"./hu/": "366f",
	"./hu/build_distance_in_words_locale": "c364",
	"./hu/build_distance_in_words_locale/": "c364",
	"./hu/build_distance_in_words_locale/index": "c364",
	"./hu/build_distance_in_words_locale/index.js": "c364",
	"./hu/build_format_locale": "ff48",
	"./hu/build_format_locale/": "ff48",
	"./hu/build_format_locale/index": "ff48",
	"./hu/build_format_locale/index.js": "ff48",
	"./hu/index": "366f",
	"./hu/index.d.ts": "d69e",
	"./hu/index.js": "366f",
	"./hu/package": "11f6",
	"./hu/package.json": "11f6",
	"./id": "03a0",
	"./id/": "03a0",
	"./id/build_distance_in_words_locale": "25bb",
	"./id/build_distance_in_words_locale/": "25bb",
	"./id/build_distance_in_words_locale/index": "25bb",
	"./id/build_distance_in_words_locale/index.js": "25bb",
	"./id/build_format_locale": "d309",
	"./id/build_format_locale/": "d309",
	"./id/build_format_locale/index": "d309",
	"./id/build_format_locale/index.js": "d309",
	"./id/index": "03a0",
	"./id/index.d.ts": "be24",
	"./id/index.js": "03a0",
	"./id/package": "be6d",
	"./id/package.json": "be6d",
	"./is": "3786",
	"./is/": "3786",
	"./is/build_distance_in_words_locale": "ab33",
	"./is/build_distance_in_words_locale/": "ab33",
	"./is/build_distance_in_words_locale/index": "ab33",
	"./is/build_distance_in_words_locale/index.js": "ab33",
	"./is/build_format_locale": "4b7c",
	"./is/build_format_locale/": "4b7c",
	"./is/build_format_locale/index": "4b7c",
	"./is/build_format_locale/index.js": "4b7c",
	"./is/index": "3786",
	"./is/index.d.ts": "91e5",
	"./is/index.js": "3786",
	"./is/package": "e470",
	"./is/package.json": "e470",
	"./it": "8666",
	"./it/": "8666",
	"./it/build_distance_in_words_locale": "3031",
	"./it/build_distance_in_words_locale/": "3031",
	"./it/build_distance_in_words_locale/index": "3031",
	"./it/build_distance_in_words_locale/index.js": "3031",
	"./it/build_format_locale": "6942",
	"./it/build_format_locale/": "6942",
	"./it/build_format_locale/index": "6942",
	"./it/build_format_locale/index.js": "6942",
	"./it/index": "8666",
	"./it/index.d.ts": "2bbd",
	"./it/index.js": "8666",
	"./it/package": "492c",
	"./it/package.json": "492c",
	"./ja": "b805",
	"./ja/": "b805",
	"./ja/build_distance_in_words_locale": "9cdb",
	"./ja/build_distance_in_words_locale/": "9cdb",
	"./ja/build_distance_in_words_locale/index": "9cdb",
	"./ja/build_distance_in_words_locale/index.js": "9cdb",
	"./ja/build_format_locale": "6eeb",
	"./ja/build_format_locale/": "6eeb",
	"./ja/build_format_locale/index": "6eeb",
	"./ja/build_format_locale/index.js": "6eeb",
	"./ja/index": "b805",
	"./ja/index.d.ts": "7af4",
	"./ja/index.js": "b805",
	"./ja/package": "04a8",
	"./ja/package.json": "04a8",
	"./ko": "896f",
	"./ko/": "896f",
	"./ko/build_distance_in_words_locale": "a04c",
	"./ko/build_distance_in_words_locale/": "a04c",
	"./ko/build_distance_in_words_locale/index": "a04c",
	"./ko/build_distance_in_words_locale/index.js": "a04c",
	"./ko/build_format_locale": "f524",
	"./ko/build_format_locale/": "f524",
	"./ko/build_format_locale/index": "f524",
	"./ko/build_format_locale/index.js": "f524",
	"./ko/index": "896f",
	"./ko/index.d.ts": "4e53",
	"./ko/index.js": "896f",
	"./ko/package": "482a",
	"./ko/package.json": "482a",
	"./mk": "1b30",
	"./mk/": "1b30",
	"./mk/build_distance_in_words_locale": "9e6c",
	"./mk/build_distance_in_words_locale/": "9e6c",
	"./mk/build_distance_in_words_locale/index": "9e6c",
	"./mk/build_distance_in_words_locale/index.js": "9e6c",
	"./mk/build_format_locale": "86dc",
	"./mk/build_format_locale/": "86dc",
	"./mk/build_format_locale/index": "86dc",
	"./mk/build_format_locale/index.js": "86dc",
	"./mk/index": "1b30",
	"./mk/index.d.ts": "4544",
	"./mk/index.js": "1b30",
	"./mk/package": "14f7",
	"./mk/package.json": "14f7",
	"./nb": "ef7b",
	"./nb/": "ef7b",
	"./nb/build_distance_in_words_locale": "48bd",
	"./nb/build_distance_in_words_locale/": "48bd",
	"./nb/build_distance_in_words_locale/index": "48bd",
	"./nb/build_distance_in_words_locale/index.js": "48bd",
	"./nb/build_format_locale": "089e",
	"./nb/build_format_locale/": "089e",
	"./nb/build_format_locale/index": "089e",
	"./nb/build_format_locale/index.js": "089e",
	"./nb/index": "ef7b",
	"./nb/index.d.ts": "9753",
	"./nb/index.js": "ef7b",
	"./nb/package": "8566",
	"./nb/package.json": "8566",
	"./nl": "8424",
	"./nl/": "8424",
	"./nl/build_distance_in_words_locale": "532b",
	"./nl/build_distance_in_words_locale/": "532b",
	"./nl/build_distance_in_words_locale/index": "532b",
	"./nl/build_distance_in_words_locale/index.js": "532b",
	"./nl/build_format_locale": "7680",
	"./nl/build_format_locale/": "7680",
	"./nl/build_format_locale/index": "7680",
	"./nl/build_format_locale/index.js": "7680",
	"./nl/index": "8424",
	"./nl/index.d.ts": "4d96",
	"./nl/index.js": "8424",
	"./nl/package": "0fd6",
	"./nl/package.json": "0fd6",
	"./package": "4278",
	"./package.json": "4278",
	"./pl": "07ac",
	"./pl/": "07ac",
	"./pl/build_distance_in_words_locale": "1540",
	"./pl/build_distance_in_words_locale/": "1540",
	"./pl/build_distance_in_words_locale/index": "1540",
	"./pl/build_distance_in_words_locale/index.js": "1540",
	"./pl/build_format_locale": "9ce6",
	"./pl/build_format_locale/": "9ce6",
	"./pl/build_format_locale/index": "9ce6",
	"./pl/build_format_locale/index.js": "9ce6",
	"./pl/index": "07ac",
	"./pl/index.d.ts": "dd2a",
	"./pl/index.js": "07ac",
	"./pl/package": "b7f4",
	"./pl/package.json": "b7f4",
	"./pt": "81d9",
	"./pt/": "81d9",
	"./pt/build_distance_in_words_locale": "6933",
	"./pt/build_distance_in_words_locale/": "6933",
	"./pt/build_distance_in_words_locale/index": "6933",
	"./pt/build_distance_in_words_locale/index.js": "6933",
	"./pt/build_format_locale": "4d34",
	"./pt/build_format_locale/": "4d34",
	"./pt/build_format_locale/index": "4d34",
	"./pt/build_format_locale/index.js": "4d34",
	"./pt/index": "81d9",
	"./pt/index.d.ts": "dfdc",
	"./pt/index.js": "81d9",
	"./pt/package": "4d58",
	"./pt/package.json": "4d58",
	"./ro": "af6c",
	"./ro/": "af6c",
	"./ro/build_distance_in_words_locale": "808f",
	"./ro/build_distance_in_words_locale/": "808f",
	"./ro/build_distance_in_words_locale/index": "808f",
	"./ro/build_distance_in_words_locale/index.js": "808f",
	"./ro/build_format_locale": "9e38",
	"./ro/build_format_locale/": "9e38",
	"./ro/build_format_locale/index": "9e38",
	"./ro/build_format_locale/index.js": "9e38",
	"./ro/index": "af6c",
	"./ro/index.d.ts": "3495",
	"./ro/index.js": "af6c",
	"./ro/package": "d492",
	"./ro/package.json": "d492",
	"./ru": "9f3f",
	"./ru/": "9f3f",
	"./ru/build_distance_in_words_locale": "2a63",
	"./ru/build_distance_in_words_locale/": "2a63",
	"./ru/build_distance_in_words_locale/index": "2a63",
	"./ru/build_distance_in_words_locale/index.js": "2a63",
	"./ru/build_format_locale": "5140",
	"./ru/build_format_locale/": "5140",
	"./ru/build_format_locale/index": "5140",
	"./ru/build_format_locale/index.js": "5140",
	"./ru/index": "9f3f",
	"./ru/index.d.ts": "8330",
	"./ru/index.js": "9f3f",
	"./ru/package": "d039",
	"./ru/package.json": "d039",
	"./sk": "5aa6",
	"./sk/": "5aa6",
	"./sk/build_distance_in_words_locale": "ab60",
	"./sk/build_distance_in_words_locale/": "ab60",
	"./sk/build_distance_in_words_locale/index": "ab60",
	"./sk/build_distance_in_words_locale/index.js": "ab60",
	"./sk/build_format_locale": "f6cc",
	"./sk/build_format_locale/": "f6cc",
	"./sk/build_format_locale/index": "f6cc",
	"./sk/build_format_locale/index.js": "f6cc",
	"./sk/index": "5aa6",
	"./sk/index.d.ts": "80f7",
	"./sk/index.js": "5aa6",
	"./sk/package": "0a3f",
	"./sk/package.json": "0a3f",
	"./sl": "2984",
	"./sl/": "2984",
	"./sl/build_distance_in_words_locale": "9a5b",
	"./sl/build_distance_in_words_locale/": "9a5b",
	"./sl/build_distance_in_words_locale/index": "9a5b",
	"./sl/build_distance_in_words_locale/index.js": "9a5b",
	"./sl/build_format_locale": "bc79",
	"./sl/build_format_locale/": "bc79",
	"./sl/build_format_locale/index": "bc79",
	"./sl/build_format_locale/index.js": "bc79",
	"./sl/index": "2984",
	"./sl/index.d.ts": "df08",
	"./sl/index.js": "2984",
	"./sl/package": "359b",
	"./sl/package.json": "359b",
	"./sr": "ee65",
	"./sr/": "ee65",
	"./sr/build_distance_in_words_locale": "2e59",
	"./sr/build_distance_in_words_locale/": "2e59",
	"./sr/build_distance_in_words_locale/index": "2e59",
	"./sr/build_distance_in_words_locale/index.js": "2e59",
	"./sr/build_format_locale": "4618",
	"./sr/build_format_locale/": "4618",
	"./sr/build_format_locale/index": "4618",
	"./sr/build_format_locale/index.js": "4618",
	"./sr/index": "ee65",
	"./sr/index.d.ts": "71c3",
	"./sr/index.js": "ee65",
	"./sr/package": "70d3",
	"./sr/package.json": "70d3",
	"./sv": "8718",
	"./sv/": "8718",
	"./sv/build_distance_in_words_locale": "50d0",
	"./sv/build_distance_in_words_locale/": "50d0",
	"./sv/build_distance_in_words_locale/index": "50d0",
	"./sv/build_distance_in_words_locale/index.js": "50d0",
	"./sv/build_format_locale": "cd33",
	"./sv/build_format_locale/": "cd33",
	"./sv/build_format_locale/index": "cd33",
	"./sv/build_format_locale/index.js": "cd33",
	"./sv/index": "8718",
	"./sv/index.d.ts": "b0ff",
	"./sv/index.js": "8718",
	"./sv/package": "ec2d",
	"./sv/package.json": "ec2d",
	"./th": "3e4f",
	"./th/": "3e4f",
	"./th/build_distance_in_words_locale": "5c01",
	"./th/build_distance_in_words_locale/": "5c01",
	"./th/build_distance_in_words_locale/index": "5c01",
	"./th/build_distance_in_words_locale/index.js": "5c01",
	"./th/build_format_locale": "59ed",
	"./th/build_format_locale/": "59ed",
	"./th/build_format_locale/index": "59ed",
	"./th/build_format_locale/index.js": "59ed",
	"./th/index": "3e4f",
	"./th/index.d.ts": "5114",
	"./th/index.js": "3e4f",
	"./th/package": "bf03",
	"./th/package.json": "bf03",
	"./tr": "dd95",
	"./tr/": "dd95",
	"./tr/build_distance_in_words_locale": "6856",
	"./tr/build_distance_in_words_locale/": "6856",
	"./tr/build_distance_in_words_locale/index": "6856",
	"./tr/build_distance_in_words_locale/index.js": "6856",
	"./tr/build_format_locale": "8e1e",
	"./tr/build_format_locale/": "8e1e",
	"./tr/build_format_locale/index": "8e1e",
	"./tr/build_format_locale/index.js": "8e1e",
	"./tr/index": "dd95",
	"./tr/index.d.ts": "f97f",
	"./tr/index.js": "dd95",
	"./tr/package": "fa9d",
	"./tr/package.json": "fa9d",
	"./zh_cn": "f2d3",
	"./zh_cn/": "f2d3",
	"./zh_cn/build_distance_in_words_locale": "29d0",
	"./zh_cn/build_distance_in_words_locale/": "29d0",
	"./zh_cn/build_distance_in_words_locale/index": "29d0",
	"./zh_cn/build_distance_in_words_locale/index.js": "29d0",
	"./zh_cn/build_format_locale": "9781",
	"./zh_cn/build_format_locale/": "9781",
	"./zh_cn/build_format_locale/index": "9781",
	"./zh_cn/build_format_locale/index.js": "9781",
	"./zh_cn/index": "f2d3",
	"./zh_cn/index.d.ts": "cf93",
	"./zh_cn/index.js": "f2d3",
	"./zh_cn/package": "9f49",
	"./zh_cn/package.json": "9f49",
	"./zh_tw": "40f9",
	"./zh_tw/": "40f9",
	"./zh_tw/build_distance_in_words_locale": "bf2c",
	"./zh_tw/build_distance_in_words_locale/": "bf2c",
	"./zh_tw/build_distance_in_words_locale/index": "bf2c",
	"./zh_tw/build_distance_in_words_locale/index.js": "bf2c",
	"./zh_tw/build_format_locale": "b981",
	"./zh_tw/build_format_locale/": "b981",
	"./zh_tw/build_format_locale/index": "b981",
	"./zh_tw/build_format_locale/index.js": "b981",
	"./zh_tw/index": "40f9",
	"./zh_tw/index.d.ts": "7d4a",
	"./zh_tw/index.js": "40f9",
	"./zh_tw/package": "bd69",
	"./zh_tw/package.json": "bd69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1422";